import gsap from 'gsap';

export default class Split {
    constructor(el, app) {
        this.el = el;
        this.app = app; // Keep reference to App

        this.options = {
            start: 'top 75%',
            end: 'top 70%',
            duration: 0.6,
            opacityFrom: 0,
            opacityTo: 1,
            topFrom: '40px',
            topTo: '0px',
            scaleFrom: 1.02,
            scaleTo: 1,
        };

        this.init();
    }

    init() {
        this.setOptions();

        this.initTimeline();
    }

    setOptions() {}

    initTimeline() {
        let splitblockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: this.options.start,
                end: this.options.end,
                // markers: true,
            },
        });

        splitblockTimeline.add('animateSPLITBLOCK');

        let img = this.el.querySelector('.split__image');
        if (img) {
            splitblockTimeline.fromTo(
                img,
                {
                    opacity: this.options.opacityFrom,
                    top: this.options.topFrom,
                    scale: this.options.scaleFrom,
                },
                {
                    duration: this.options.duration,
                    opacity: this.options.opacityTo,
                    top: this.options.topTo,
                    scale: this.options.scaleTo,
                },
                'animateSPLITBLOCK'
            );
        }
    }
}
